import { DataTableColumnHeader, Text } from "@/components/ui";
import { CurrencyWrapper } from "@/components/ui/CurrencyWrapper/CurrencyWrapper";
import { type MatterPropertyDamage } from "@/lib/types";
import { convertToLocalFromDatabaseDateTime } from "@/lib/utils/dateUtils";
import { formatDate } from "@/lib/utils/format";
import { createColumnHelper, type ColumnDef } from "@tanstack/react-table";

const columnHelper = createColumnHelper<MatterPropertyDamage>();

export const matterPropertyDamageColumns: ColumnDef<MatterPropertyDamage>[] = [
  columnHelper.accessor("dateCreated", {
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    sortingFn: "customDateTime",
    id: "Date Created",
    cell: (cell) => (
      <Text variant="subHeading">
        {formatDate(
          convertToLocalFromDatabaseDateTime(cell.getValue() ?? undefined),
        )}
      </Text>
    ),
  }),
  columnHelper.accessor("label", {
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    id: "Label",
    enableHiding: false,
    cell: ({ cell }) => (
      <Text variant="body" className="font-semibold">
        {cell.getValue()}
      </Text>
    ),
  }),
  columnHelper.accessor("paymentDate", {
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    id: "Payment Date",
    cell: (cell) => (
      <Text variant="subHeading">
        {cell.getValue() ? formatDate(cell.getValue()) : "-"}
      </Text>
    ),
  }),
  columnHelper.accessor("originalAmount", {
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    id: "Original Amount",
    cell: ({ cell }) => (
      <Text variant="subHeading">
        <CurrencyWrapper value={cell.getValue() || 0} />
      </Text>
    ),
  }),
  columnHelper.accessor("paidAmount", {
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    id: "Paid Amount",
    cell: ({ cell }) => (
      <Text variant="subHeading">
        <CurrencyWrapper value={cell.getValue() || 0} />
      </Text>
    ),
  }),
  {
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    id: "Balance Remaining",
    cell: ({ row }) => {
      if (!row.original.originalAmount) {
        return <Text variant="subHeading">-</Text>;
      }
      const balanceRemaining =
        row.original.originalAmount - (row.original.paidAmount ?? 0);
      return (
        <Text variant="subHeading">
          <CurrencyWrapper value={balanceRemaining} />
        </Text>
      );
    },
  },
] as ColumnDef<MatterPropertyDamage>[];
